import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TypologyService } from '../../shared/services/typology.services';
import { IOperatorsOptions, IStructureOptions } from '../../shared/models/interfaces/typology.interface';
import { catchError, tap } from 'rxjs';
import { MyReservationService } from '../../shared/services/my-reservations.service';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'ngb-operator-shift-assignment',
  templateUrl: './operator-shift-assignment.component.html',
  styleUrl: './operator-shift-assignment.component.scss',
  imports: [
    SharedModule
  ],
})
export class OperatorShiftAssignmentComponent implements OnInit, AfterViewInit {
  
  //PER TABELLA:
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  formFilters : FormGroup;
  establishmentOptions : IStructureOptions[] = [];

  //PER TABELLA:
  listOperators: IOperatorsOptions[] = [];
  displayedColumns: string[] = ['name', 'surname', 'tax-code','email', 'phone','active', 'azioni'];
  dataSource = new MatTableDataSource<IOperatorsOptions>(this.listOperators);

  private readonly _fb: FormBuilder = inject(FormBuilder);
  private readonly _typologyService: TypologyService = inject(TypologyService);
  private readonly _myReservationService: MyReservationService = inject(MyReservationService);
  private readonly _router: Router = inject(Router);

  ngOnInit(): void {
    this.formFilters = this._fb.group({
      establishment:this._fb.control(null),
      name:this._fb.control(null),
      surname:this._fb.control(null)
    })

    this._typologyService.getTypologyStructure().pipe(
      tap(establishment => this.establishmentOptions = establishment)
    ).subscribe();

  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  navigate(){
    this._router.navigate(['dashboard']);
  }

  onChangeStructure(strutture:IStructureOptions){
    let { id } = strutture;
    this._myReservationService.getOperatorsByStructure( id ).pipe(
      tap( operators => {
        this.listOperators = operators;
        this.dataSource.data = operators;
      }),
      catchError((err) => {
        this.listOperators = [];
        this.dataSource.data = [];
        return [];
      })
    ).subscribe();
  }

  applyFilters() {
    const name = this.formFilters.get('name')?.value?.toLowerCase() || '';
    const surname = this.formFilters.get('surname')?.value?.toLowerCase() || '';

    this.dataSource.data = this.listOperators.filter(operator => {
      const matchesName = operator.name?.toLowerCase().includes(name);
      const matchesSurname = operator.surname?.toLowerCase().includes(surname);
      return matchesName && matchesSurname;
    });
  }

  detailOperator(operator:IOperatorsOptions){
    this._router.navigate([`operator-shifts/detail-operator/${operator.id}`]);
  }

}
